import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';

@Injectable({
  providedIn: 'root',
})
export class NotAuthGuard {
  environmentConfig = inject(ENVIRONMENT_CONFIG);

  constructor(
    public auth: AuthService,
    public router: Router
  ) {}

  canActivate(): boolean {
    if (!this.auth.isSignIn()) {
      void this.router.navigateByUrl(this.environmentConfig.routes['sign-in']);
      return false;
    }
    return true;
  }
}
